import { render, staticRenderFns } from "./AddEstimateSectionModal.vue?vue&type=template&id=52ff80bf&"
import script from "./AddEstimateSectionModal.vue?vue&type=script&lang=js&"
export * from "./AddEstimateSectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports